import React from "react";
import { FaRedo } from "react-icons/fa";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";

import LexiqueEmptyState from "./components/LexiqueEmptyState";
import LexiqueHero from "./components/LexiqueHero";
import LexiqueList from "./components/LexiqueList";
import LexiqueSkeleton from "./components/LexiqueSkeleton";
import LexiqueStats from "./components/LexiqueStats";
import LexiqueToolbar from "./components/LexiqueToolbar";

import { useLexiquePage } from "./hooks/useLexiquePage";

function LexiquePage() {
  useScrollToTop();

  const {
    lexique,
    filteredLexique,
    groupedLexique,
    discipline,
    filters,
    availableLetters,
    stats,
    loading,
    refreshing,
    activeFiltersCount,
    fetchLexique,
    handleFilterChange,
    resetFilters,
  } = useLexiquePage();

  return (
    <main className="min-h-screen bg-slate-50 pb-24 pt-[88px] text-slate-950 dark:bg-slate-950 dark:text-white lg:pt-[104px]">
      <LexiqueHero discipline={discipline} stats={stats} />

      <section className="mx-auto -mt-12 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-white/80 bg-white/95 p-4 shadow-2xl shadow-slate-200/70 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/30 sm:p-6">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-indigo-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200">
                Lexique {discipline || "Judo"}
              </div>

              <h1 className="mt-4 font-titre text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-4xl">
                Lexique japonais / français
              </h1>

              <p className="mt-3 max-w-3xl text-sm font-medium leading-7 text-slate-600 dark:text-white/60 sm:text-base">
                Recherche rapidement un terme, sa traduction ou révise le
                vocabulaire par lettre. La page s'adapte automatiquement à la
                discipline configurée dans l'application.
              </p>
            </div>

            <button
              type="button"
              onClick={fetchLexique}
              disabled={refreshing}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-indigo-200 hover:text-indigo-700 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:hover:border-indigo-300/40 dark:hover:text-indigo-100 lg:min-w-[220px]"
            >
              <FaRedo className={refreshing ? "animate-spin" : ""} />
              {refreshing ? "Actualisation..." : "Actualiser"}
            </button>
          </div>

          <LexiqueStats stats={stats} discipline={discipline} />
        </div>
      </section>

      <section className="mx-auto mt-6 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <LexiqueToolbar
          filters={filters}
          availableLetters={availableLetters}
          totalCount={lexique.length}
          resultsCount={filteredLexique.length}
          activeFiltersCount={activeFiltersCount}
          onFilterChange={handleFilterChange}
          onReset={resetFilters}
        />

        {loading ? (
          <LexiqueSkeleton />
        ) : filteredLexique.length > 0 ? (
          <LexiqueList groupedLexique={groupedLexique} />
        ) : (
          <LexiqueEmptyState onReset={resetFilters} />
        )}
      </section>

      <DashboardNavigation />
      <ScrollIndicator />
    </main>
  );
}

export default LexiquePage;